import React, { useState } from "react";
import { HamburgetMenuClose, HamburgetMenuOpen } from "./Icons";
import { useAuth } from './AuthProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginModal from './LoginModal';
import RegisterModal from './Register';
import { useNavigate } from "react-router-dom";
import '../css/style.css';
import axios from 'axios';

function NavBar({ onSelectSection }) {
    const [click, setClick] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleUserClick = () => {
        navigate('/user');
    };

    const handleClick = () => setClick(!click);
    const handleLoginModalClose = () => setShowLoginModal(false);
    const handleLoginModalShow = () => {
        setShowRegisterModal(false);
        setShowLoginModal(true);
    };
    const handleRegisterModalClose = () => setShowRegisterModal(false);
    const handleRegisterModalShow = () => {
        setShowLoginModal(false);
        setShowRegisterModal(true);
    };

    const handleUpdateCache = async () => {
        try {
            await axios.get(`${process.env.REACT_APP_API_BASE_URL}/cache/update`);
            window.location.reload();
        } catch (error) {
            console.error("Cache update failed", error);
            alert("Update failed");
        }
    };

    const logoUrl = `${process.env.REACT_APP_API_BASE_URL}/logo`;
    // feature flag to enable auth UI (set REACT_APP_AUTH_FEATURE_ENABLED=true to show login/register)
    const authFeatureEnabled = process.env.REACT_APP_AUTH_FEATURE_ENABLED === 'true';

    return (
        <>
            <nav className="nav-bar">
                <div className="nav-container navbar navbar-light bg-light-pink py-lg-0 px-lg-4">
                    <div className="d-flex align-items-center col m-0 p-0">
                        <img className="navbar-brand" src={logoUrl} alt={""}/>
                    </div>
                    {user ? (
                        <>
                            <div onClick={handleUserClick} className="nav-item nav-link"
                                 style={{cursor: 'pointer'}}>{user.name}</div>
                            <div onClick={logout} className="nav-item nav-link">Logout</div>
                        </>
                    ) : (
                        authFeatureEnabled && (
                            <>
                                <div onClick={handleLoginModalShow} className="login">Login</div>
                                {/*<div onClick={handleRegisterModalShow} className="nav-item nav-link">Register</div>*/}
                            </>
                        )
                    )}
                    <div onClick={handleUpdateCache} className="update" style={{cursor: 'pointer'}}>UC
                    </div>
                </div>
                <div className="nav-container navbar-expand-lg navbar-light bg-light-pink py-lg-0 px-lg-4">
                    <div className={"navbar-nav bg-light-pink " + (click ? "active" : "")}>
                        <div onClick={() => moveFromNavBar("news")} className="nav-item nav-link">Aktualności</div>
                        <div onClick={() => moveFromNavBar("acts")} className="nav-item nav-link">Numery</div>
                        <div onClick={() => moveFromNavBar("services")} className="nav-item nav-link">Oferta</div>
                        <div onClick={() => moveFromNavBar("events")} className="nav-item nav-link">
                            Szczególne wydarzenia
                        </div>
                        <div onClick={() => moveFromNavBar("calendar")} className="nav-item nav-link">Kalendarium
                        </div>
                    </div>
                    <div className="nav-icon" onClick={handleClick}>
                        {click ? (
                            <span className="icon"><HamburgetMenuClose/></span>
                        ) : (
                            <span className="icon"><HamburgetMenuOpen/>{" "}</span>
                        )}
                    </div>
                </div>
            </nav>
            {authFeatureEnabled && (
                <>
                    <LoginModal show={showLoginModal} handleClose={handleLoginModalClose} className="modal-top-right"/>
                    <RegisterModal show={showRegisterModal} handleClose={handleRegisterModalClose} className="modal-top-right" />
                </>
            )}
        </>
    );

    function moveFromNavBar(section) {
        if (typeof onSelectSection === 'function') {
            onSelectSection(section === 'carousel' ? 'aktualnosci' : section);
        }
        handleClick();
    }
}

export default NavBar;